'use strict';

module.exports = {};



// WEBPACK FOOTER //
// ./src/stream.browser.js